var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.73 7.228a.32.32 0 0 1 .538 0l.363.57c.401.63.936 1.165 1.566 1.567l.57.362a.32.32 0 0 1 0 .539l-.57.363a5.1 5.1 0 0 0-1.566 1.566l-.363.57a.32.32 0 0 1-.539 0l-.362-.57A5.1 5.1 0 0 0 7.8 10.63l-.57-.363a.32.32 0 0 1 0-.539l.57-.362a5.1 5.1 0 0 0 1.567-1.567z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.257 4.403c2.47.179 4.064-2.322 6.766-2.322 2.662-.053 3.965 2.356 6.694 2.356 1.463 7.447-1.58 12.125-6.671 13.476-4.72-1.121-8.266-5.847-6.789-13.51Z"
  })));
};
export default SvgShield;